import { VueRouterFactory } from '@scfe-common/micro-frontend-utils';

import App from '@/App';

import { history, ReactRoutes, reactRoutes } from './react';

export const { routes: vueRoutes } = new VueRouterFactory({
  uniquename: __UNIQUENAME__,
  basename: __ROUTE_NAME_SPACE__,
  App,
  history,
  ReactRoutes,
  configs: reactRoutes,
});
